import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useCustomersStore } from '@lib/store';
import { useDebounce } from '@shared/hooks';
import type { CustomerSearchParams } from '@shared/api';
import { Input } from '@shared/widgets';

export const CustomersSearchForm = () => {
  const { getCustomers } = useCustomersStore();

  const [filters, setFilters] = useState<CustomerSearchParams>({});

  const debouncedFilters = useDebounce(filters);
  useEffect(() => {
    getCustomers(debouncedFilters);
  }, [debouncedFilters]);

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='accountNumber'
            label='Account Number'
            value={filters.accountNumber || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, accountNumber: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='cardNumber'
            label='Card Number'
            value={filters.cardNumber || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, cardNumber: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='fullName'
            label='Full Name'
            value={filters.fullName || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, fullName: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='passport'
            label='Passport / ID Card Number'
            value={filters.passportIdCard || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, passportIdCard: e.target.value }))}
          />
        </Grid>
      </Grid>
    </form>
  );
};
